//#region Util Imports

import * as _ from "underscore";
import * as $ from "jquery";

//#endregion

//#region DevExpress Imports

import DevExpress from "devextreme";
import { AsyncRule, CompareRule, CustomRule, EmailRule, NumericRule, PatternRule, RangeRule, RequiredRule, StringLengthRule } from "devextreme/ui/validation_engine";

//#endregion

import { Enums } from "../../../../models/common";
import { LocalizationHelper } from "../../../../helpers";
import { UserSessionService } from "../../../../services/user-session";
import { KingspanConfigurationFormService } from "../service";
import { IMRBaseControlController } from "../../../../modules/common/base";
import {
    IIMRInstallationCategoryPopup,
    IMRIIMRInstallationCategoryPopupOptions,
} from "./ks-inst-cat-cr-ed-popup.interfaces";
import { DescrType } from "../../../../modules/common/select-add-descr/select-add-descr.directive";
import { IIMRPopup, IMRPopupOptions } from "@imr/controls.angularjs/components/overlay/popup";
import { IMRComponentInitializedArgs } from "@imr/controls.angularjs/components/base";
import { OpInstallationCategory } from "../../../../models/custom/op-installation-category";
import { OpDescr } from "../../../../models/core";
import { DescrModel } from "../../../../modules/api/api.models";
import { BackwardCompatibilityHelper } from "../../../../helpers/backward-compatibility-helper";

type DxFormItem = (DevExpress.ui.dxFormSimpleItem | DevExpress.ui.dxFormGroupItem | DevExpress.ui.dxFormTabbedItem | DevExpress.ui.dxFormEmptyItem | DevExpress.ui.dxFormButtonItem)
type DxValidationRule = (RequiredRule | NumericRule | RangeRule | StringLengthRule | CustomRule | CompareRule | PatternRule | EmailRule | AsyncRule)

export const COMPONENT_NAME: string =
    "kingspanInstallationCategoryCreateEditPopup";

export class KingspanInstallationCategoryPopupController
    extends IMRBaseControlController<
        IIMRInstallationCategoryPopup,
        IMRIIMRInstallationCategoryPopupOptions
    >
    implements IIMRInstallationCategoryPopup {
    private formOptions: DevExpress.ui.dxFormOptions;
    private form: DevExpress.ui.dxForm;

    private imrPopupOptions: IMRPopupOptions
    private imrPopup: IIMRPopup

    private deleteButtonOptions: DevExpress.ui.dxButtonOptions

    private installationCategory: OpInstallationCategory
    private udiInputsToDelete: OpDescr[]

    private formValidationGroupOptions: DevExpress.ui.dxValidationGroupOptions
    private formValidationGroup: DevExpress.ui.dxValidationGroup

    private descrValidationRulles: DxValidationRule[]

    private submitButton: DevExpress.ui.dxButton

    constructor(
        private userSession: UserSessionService,
        private kingspanService: KingspanConfigurationFormService
    ) {
        super();
    }

    //#region Component

    protected initialize(options: IMRIIMRInstallationCategoryPopupOptions) {
        this.setOptions();
    }

    //#endregion

    private setOptions(): void {
        this.setImrPopupOption()
        this.setFormOptions()
        this.setAdditionalItemsOptions()
    }

    private setAdditionalItemsOptions(): void {
        this.deleteButtonOptions = {
            icon: 'trash',
            stylingMode: 'text',
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Delete),
            onClick: (e: any): void => { this.deleteUdiInput(e) },
            onInitialized: (e: any): void => {
                const index: number = +e.element.get(0).attributes['element-id'].nodeValue
                e.component.option('disabled', this.isInCommonUdiDescriptionRange(index))
            }
        }

        this.formValidationGroupOptions = {
            onInitialized: (e: any) => {
                this.formValidationGroup = e.component
            },
        }

        this.descrValidationRulles = [
            {
                type: 'required',// "custom",
                message: LocalizationHelper.getLocalizedText(
                    LocalizationHelper.Text.RequiredField
                ),
                validationCallback: (e: any) => {
                    return e.value != null
                }
            },
        ]
    }

    private setImrPopupOption() {
        this.imrPopupOptions = {
            innerOptions: {
                maxWidth: 700,
                height: 450,
                onHiding: (e: any): void => {
                }
            },
            onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
                this.imrPopup = e.component
            },
            bottomToolbarOptions: {
                items: [{
                    location: 'after',
                    widget: 'dxButton',
                    options: <DevExpress.ui.dxButtonOptions>{
                        text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Submit),
                        hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Submit),
                        disabled: true,
                        onInitialized: (e: any) => {
                            this.submitButton = e.component
                        },
                        onClick: (e: any) => {
                            this.onSubmitForm()
                        }
                    },

                }, {
                    location: 'after',
                    widget: 'dxButton',
                    options: <DevExpress.ui.dxButtonOptions>{
                        text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
                        hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
                        onClick: (e: any) => {
                            if (this.imrPopup != null) {
                                this.imrPopup.hide()
                            }
                        }
                    }
                }]
            }
        }
    }

    private onSubmitForm(): void {
        const validateForm = this.form.validate()

        if (validateForm.isValid == true) {
            const validateGroup = this.formValidationGroup.validate()

            if (validateGroup.isValid == true) {
                if (_.isFunction(this.options.onSubmit)) {
                    this.imrPopup.showLoading()

                    if (_.size(this.udiInputsToDelete) > 0) {
                        this.installationCategory.deviceUdiDescriptions.push(..._.map(this.udiInputsToDelete, (input: OpDescr) => {
                            const toDelete: OpDescr = OpDescr.restore(input)
                            toDelete.opState = Enums.OpChangeState.Delete
                            return toDelete
                        }))
                    }

                    this.options
                        .onSubmit(this.installationCategory)
                        .then(() => {
                            this.imrPopup.hide()
                        })
                        .catch(() => {
                            this.restoreUdiItemsAfterException()
                        })
                        .always(() => {
                            this.imrPopup.hideLoading()
                        })
                }
            }
        }
    }

    private restoreUdiItemsAfterException(): void {
        if (_.size(this.udiInputsToDelete) > 0) {
            _.forEach(this.installationCategory.deviceUdiDescriptions, (udi: OpDescr) => {
                const toDelee: OpDescr = _.find(this.udiInputsToDelete, (toDel: OpDescr) => { return toDel.idDescr == udi.idDescr })

                if (toDelee != null) {
                    udi.description = toDelee.description
                    udi.opState = toDelee.opState
                }
            })
            this.udiInputsToDelete = []
            this.installationCategory.deviceUdiDescriptions = [
                ..._.sortBy(
                    _.filter(this.installationCategory.deviceUdiDescriptions, (udi: OpDescr) => { return udi.idDescr > 0 }),
                    (udi: OpDescr) => { return udi.idDescr }),
                ..._.filter(this.installationCategory.deviceUdiDescriptions, (udi: OpDescr) => { return udi.idDescr == 0 })]
            this.updateFromUdiDescriptionFields(this.installationCategory.deviceUdiDescriptions)
        }
    }

    private setFormOptions(): void {
        this.formOptions = {
            colCount: 2,
            bindingOptions: {
                formData: '$ctrl.installaTionCategory'
            },
            height: '100%',
            scrollingEnabled: true,
            onInitialized: (e: any): void => {
                this.form = e.component;

                if (this.installationCategory.deviceUdiDescriptions == null) {
                    this.installationCategory.deviceUdiDescriptions = []
                }
            },
        }
    }

    private getFormItems(): DxFormItem[] {
        return [
            {
                itemType: "group",
                caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InstallationCategory),
                name: "category-container",
                items: [
                    <DevExpress.ui.dxFormSimpleItem>{
                        label: {
                            visible: false
                        },
                        template:
                            '<select-add-descr style="width:100%;" current="$ctrl.installationCategory.installationCategory" element-id="' +
                            -1 +
                            '" property-name="' +
                            -1 +
                            '" type="' +
                            DescrType.ItemType +
                            ' "disabled="' + this.isInCommonInstallationCategoryRange() +
                            '" callback="$ctrl.onDescrSelectionChanged" validation-rulles="$ctrl.descrValidationRulles"></select-add-descr>'
                    }
                ],
            },
            {
                itemType: "group",
                caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InputName),
                name: "inputs-container",
                items: [
                    {
                        itemType: "group",
                        name: "inputs",
                        items: this.getUdiInputsOptions(this.installationCategory != null ? this.installationCategory.deviceUdiDescriptions : []),
                    },
                    {
                        itemType: "button",
                        horizontalAlignment: "left",
                        buttonOptions: {
                            icon: "add",
                            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AddInput),
                            disabled: this.isInCommonInstallationCategoryRange(),
                            onClick: () => {
                                if (this.installationCategory.deviceUdiDescriptions == null) {
                                    this.installationCategory.deviceUdiDescriptions = [];
                                }

                                this.installationCategory.deviceUdiDescriptions.push(null);
                                this.updateFromUdiDescriptionFields(this.installationCategory.deviceUdiDescriptions)
                                this.updateSubmitButtonState()
                            },
                        },
                    },
                ],
            },
        ]
    }
    private getUdiInputsOptions(inputs: OpDescr[]): DxFormItem[] {
        const options: DxFormItem[] = []

        if (inputs == null) {
            inputs = []
        }

        for (let i = 0; i < inputs.length; i += 1) {
            options.push(this.generateNewUdiInputOptions(i));
        }

        return options;
    }

    private deleteUdiInput(e: any): void {
        const index: number = +e.element.get(0).attributes['element-id'].nodeValue
        const inputToDelete: OpDescr = this.installationCategory.deviceUdiDescriptions[index]

        if (inputToDelete != null && inputToDelete.idDescr != 0) {
            this.udiInputsToDelete.push(inputToDelete)
        }

        this.installationCategory.deviceUdiDescriptions.splice(index, 1)

        this.updateFromUdiDescriptionFields(this.installationCategory.deviceUdiDescriptions)
        this.updateSubmitButtonState()
    }

    private generateNewUdiInputOptions(index: number): DxFormItem {
        return <DevExpress.ui.dxFormSimpleItem>{
            label: {
                visible: false
            },
            template:
                '<div style="display:flex;flex-direction:row;width:100%;gap:5px;">' +
                '<select-add-descr style="width:100%;" current="$ctrl.installationCategory.deviceUdiDescriptions[' + index + ']" element-id="' +
                index +
                '" property-name="' +
                index +
                '" type="' +
                DescrType.ItemType +
                ' "disabled="' + this.isInCommonUdiDescriptionRange(index) +
                '" callback="$ctrl.onDescrSelectionChanged" validation-rulles="$ctrl.descrValidationRulles"></select-add-descr><div dx-button="$ctrl.deleteButtonOptions" element-id="' + index + '"></div></div>',
        };
    }

    private onDescrSelectionChanged = (elementId: number, propertyName: string, selectedItem: DescrModel) => {
        const category: OpDescr = BackwardCompatibilityHelper.DescrModelToOpDescr(selectedItem)

        if (elementId == -1) {
            category.extendedDescription = 'IdLocationInstallationCategory'

            _.forEach(category.allLanguagesDescription, (descr: OpDescr) => {
                descr.extendedDescription = 'IdLocationInstallationCategory'
            })

            this.installationCategory.installationCategory = category
        } else if (elementId > -1) {
            category.extendedDescription = 'IdDeviceUdiDescription'

            _.forEach(category.allLanguagesDescription, (descr: OpDescr) => {
                descr.extendedDescription = 'IdDeviceUdiDescription'
            })

            this.installationCategory.deviceUdiDescriptions[elementId] = category
        }

        this.updateSubmitButtonState()
    }

    private updateFromUdiDescriptionFields(descriptions: OpDescr[]): void {
        if (this.form != null) {
            this.form.repaint()
            this.form.itemOption(
                "inputs-container.inputs",
                "items",
                this.getUdiInputsOptions(descriptions)
            );
        }
    }

    private isSubmitButtonDisabled(): boolean {
        return (this.isInCommonInstallationCategoryRange()
            || this.installationCategory == null
            || _.size(this.installationCategory.deviceUdiDescriptions) == 0)
    }

    private updateSubmitButtonState(): void {
        if (this.submitButton != null) {
            this.submitButton.option('disabled', this.isSubmitButtonDisabled())
        }
    }

    private isInCommonInstallationCategoryRange(): boolean {
        if (this.installationCategory == null || this.installationCategory.installationCategory == null) {
            return false
        }

        return this.kingspanService.isDescrInCommonInstallationCategoryRange(this.installationCategory.installationCategory.idDescr)
    }

    private isInCommonUdiDescriptionRange(index: number): boolean {
        if (index == null || this.installationCategory == null || this.installationCategory.deviceUdiDescriptions == null || this.installationCategory.deviceUdiDescriptions.length < index) {
            return false
        }

        const selectedUdiDescr: OpDescr = this.installationCategory.deviceUdiDescriptions[index]

        if (selectedUdiDescr == null) {
            return false
        }

        return this.kingspanService.isDescrInCommonUdiDescriptionRange(this.installationCategory.deviceUdiDescriptions[index].idDescr)
    }

    //#region IIMRInstallationCategoryPopup

    public showPopup(value: OpInstallationCategory = null): void {
        if (this.imrPopup != null) {
            if (value == null) {
                this.installationCategory = new OpInstallationCategory(null)
                this.imrPopup.getInnerPopup().option('title', LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AddInstallationCategory))
            } else {
                this.installationCategory = OpInstallationCategory.restore(value)
                this.imrPopup.getInnerPopup().option('title', LocalizationHelper.getLocalizedText(LocalizationHelper.Text.EditInstallationCategory))
            }

            this.udiInputsToDelete = []

            if (this.form != null) {
                this.form.option('items', this.getFormItems())
            } else {
                this.formOptions.items = this.getFormItems()
            }

            this.updateSubmitButtonState()
            this.imrPopup.show();
        }
    }

    public hidePopup(): void {
        if (this.imrPopup != null) {
            this.imrPopup.hide();
        }

        if (this.submitButton != null) {
            this.submitButton.option('disabled', true)
        }
    }

    //#endregion
}
